"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const affinity_metrics_lib_1 = require("@affinidi/affinity-metrics-lib");
const parsers_1 = require("./parsers");
class MetricsServiceOptions {
}
class MetricsService {
    constructor(options) {
        this._accessApiKey = options.accessApiKey;
        this._metricsUrl = options.metricsUrl;
        this._component = options.component;
        this._vcMetadataParserFactory = new parsers_1.VcMetadataParserFactory();
    }
    send(event) {
        affinity_metrics_lib_1.metrics.send(event, this._accessApiKey, this._metricsUrl);
    }
    parseVcMetadata(credential, name) {
        let vcMetadataParser;
        switch (name) {
            // parse common + type-specific metadata for the following events
            case affinity_metrics_lib_1.EventName.VC_SAVED:
            case affinity_metrics_lib_1.EventName.VC_VERIFIED:
            case affinity_metrics_lib_1.EventName.VC_VERIFIED_PER_PARTY:
                vcMetadataParser = this._vcMetadataParserFactory.createParser(credential.type[1]);
                break;
            // parse only common metadata otherwise
            default:
                vcMetadataParser = this._vcMetadataParserFactory.createParser('default');
        }
        const metadata = vcMetadataParser.parse(credential);
        return metadata;
    }
    _isTestEnvironment() {
        let isTestEnvironment = false;
        if (process && process.env) {
            isTestEnvironment = process.env.NODE_ENV === 'test';
        }
        return isTestEnvironment;
    }
    sendVcEvent(credential, options) {
        if (this._isTestEnvironment()) {
            return;
        }
        const metadata = this.parseVcMetadata(credential, options.name);
        if (options.verificationMetadata) {
            metadata.verification = options.verificationMetadata;
        }
        const event = {
            component: this._component,
            link: options.link,
            secondaryLink: options.secondaryLink,
            name: options.name,
            category: affinity_metrics_lib_1.EventCategory.VC,
            subCategory: options.subcategory || '',
            metadata: metadata,
        };
        this.send(event);
    }
    sendVpEvent(options) {
        if (this._isTestEnvironment()) {
            return;
        }
        let metadata;
        if (options.verificationMetadata) {
            metadata = { verification: options.verificationMetadata };
        }
        const event = {
            component: this._component,
            link: options.link,
            secondaryLink: options.secondaryLink,
            name: options.name,
            category: affinity_metrics_lib_1.EventCategory.VP,
            subCategory: options.subcategory || '',
            metadata: metadata,
        };
        this.send(event);
    }
}
exports.default = MetricsService;
//# sourceMappingURL=MetricsService.js.map